import { categories } from '@/mocks/homepage';
import CategoryCard from '@/components/feature/CategoryCard';

export default function CategoriesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大精选分类，覆盖时尚、生活、才艺等多个领域，满足你对美的全方位追求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <CategoryCard
              key={cat.slug}
              slug={cat.slug}
              name={cat.name}
              icon={cat.icon}
              description={cat.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}